import viewEvents from '../../../helpers/viewEvents';
import { getLocalizedTitle } from '../utils/promotions';
import h, { shouldShowParentalRatingPopup } from '../../../helpers/common';
import channelsUtil from '../../../helpers/channelsUtil';
import { ParentalLock } from '../../../components/elements/ParentalLock';
import { appConfig } from '../../../config/app.config';
import { getPromotionCTAUrl, getPromotionRoutePath } from '@intigral/utils/lib/helpers/promotion';
import url from '../../../helpers/url';
import user from '../../../helpers/user';

export const handleDetailsPage = ({ item, showDetailsPage, openDetailOverlay }) => {
    if (!showDetailsPage(item)) return false;
    openDetailOverlay(item);
    return true;
};

export const handleCatchupNavigation = ({ item, userChannels, navigate }) => {
    if (item.promoType !== 'CATCHUP') return false;

    if (item?.ratings && shouldShowParentalRatingPopup(item?.ratings)) {
        viewEvents.broadcast('openPopup', { component: <ParentalLock />, screen: 'catchupPlayer' });
        return true;
    }

    const channel = channelsUtil.getChannelByStationId(item.stationId, userChannels);
    if (!channel) return true;

    const lang = h.getLang();
    const title = getLocalizedTitle(item.programTitle, lang);
    const channelTitle = getLocalizedTitle({ ar: channel?.channelTitleAr, en: channel?.channelTitle }, lang);

    navigate('/catchup-player', {
        state: {
            programData: {
                title,
                name: title,
                channelTitle,
                startTime: item?.startTime || 0,
                endTime: item?.endTime || 0,
                tuningURLs: {
                    catchUpURL: channel?.tuningURLs?.catchUpURL || '',
                },
                channelName: channelTitle,
                channelNumber: channel?.channelNumber,
                ...(Array.isArray(channel?.category) &&
                    channel.category[0] && {
                        channelCategory: channel.category[0],
                    }),
                poster: item?.image,
                guid: item?.guid,
                paId: item?.paId,
            },
        },
    });

    return true;
};

export const handleRouteNavigation = ({ item, navigate }) => {
    if (item.promoType !== 'ROUTE' || !item.screenId) return false;

    const lang = h.getLang();
    navigate(getPromotionRoutePath(item.screenId, lang, appConfig.defaultLanguage));
    return true;
};

export const handleDefaultNavigation = ({ item, navigate }) => {
    const cta = getPromotionCTAUrl(item, url, user);
    if (!cta) {
        return true;
    }

    // Excluded types
    if (item.promoType === 'SUBSCRIPTION' || item.promoType === 'TIER') {
        return false;
    }

    navigate(cta);
    return true;
};
